import 'sumoselect';
import validationRules from './validation';
import getStateCode from './getStateCode';
import InputMask from 'inputmask';

window.$ = jQuery;

var pId = "AkZxsBJ-8d-0uCtEGU_SvP_twJ761g";

function validateItem(el) {
    let errors = 0;
    if ($(el).is('select')) {
        errors += validationRules.selectValidate(el) ? 0 : 1;
    } else if ($(el).attr('type') === 'radio') {
        errors += validationRules.radioValidate(el) ? 0 : 1;
    } else if ($(el).hasClass('zipcode')) {
        errors += validationRules.zipValidate(el) ? 0 : 1;
    } else if ($(el).hasClass('email')) {
        errors += validationRules.emailValidate(el) ? 0 : 1;
    } else if ($(el).hasClass('phone')) {
        errors += validationRules.phoneValidate(el) ? 0 : 1;
    } else if ($(el).hasClass('dob')) {
        errors += validationRules.dobValidate(el) ? 0 : 1;
    } else if ($(el).attr('type') === 'hidden') {
        // do nothing
    } else {
        errors += validationRules.textValidate(el) ? 0 : 1;
    }
    return errors;
}

function validateFormData() {
    let errors = 0;
    $("#submit-form").find("input, select").each(function(_, el) {
        errors += validateItem(el);
    });

    return (errors === 0);
}

function setupFormListeners() {
    $("#submit-form").find("input, select").on('blur', function() {
        validateItem(this);
    });

    $('select').SumoSelect();
}

function populateHiddenFields() {
    // state by zipcode
    let zip = $("input[name='postal_code']").val().substring(0, 5);
    $("input[name='state']").val( getStateCode(zip) );

    let gender = $("input[name='gender']").val();
    let birth = $("input[name='dob']").val();

    localStorage.setItem('zipcode', zip);
    localStorage.setItem('gender', gender);
    localStorage.setItem('birth_date', birth);
}

function getUrlVars()
{
    var vars = [], hash, uri = window.location.href;
    var hashes = decodeURIComponent(uri).slice(window.location.href.indexOf('?') + 1).split('&');
    if(uri.indexOf('?') > -1) {
        for(var i = 0; i < hashes.length; i++)
        {
            if(hashes[i].indexOf('#')) {
                hash = hashes[i].split('#').shift().split('='); 
            } else {
                hash = hashes[i].split('=');                        
            }

            if(hash[0] === "gender" || hash[0] === "employment_status" || hash[0] === "health_status") {
                vars[hash[0]] = hash[1].toLowerCase();
            } else {
                vars[hash[0]] = hash[1];
            }
        }    
    }
    return vars;
}

$(document).on('submit', 'form#submit-form', function(e) {
    e.preventDefault();

    let success = validateFormData();
    if (!success) {
        return;
    }

    $(".btn-text").addClass("d-none");
    $(".spinner-border").removeClass("d-none");
    populateHiddenFields();
    gtmDataQuotePush();
    let formData = $("form#submit-form").serialize();
    // console.log(formData); // for dev review

    // post to Media Alpha
    $.ajax({
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        url: window.endpointUrl,
        data: formData,
        success: function(requestData) {
            window.location.hash = "thank-you";
            $(".btn-text").removeClass("d-none");
            $(".spinner-border").addClass("d-none");
            // console.log(JSON.stringify(requestData));
        }
    });
});

//Click handler on request quote button for GTM push
$(document).on('click', '#request', function() {
    dataLayer.push({
        'event': 'customEvent',
        'eventCategory' : 'Landing Page - Lead Submission Flow',
        'eventAction' : 'Request A Quote Today', 
        'eventLabel' : 'Why Wait To Get The Life Insurance Plan', 
      });      
});


//Click handler on header links for GTM push
$(document).on('click', '.header-logos', function() {
    let val = $(this).data('val')
    dataLayer.push({
        'event': 'customEvent',
        'eventCategory' : 'Navigation',
        'eventAction' : 'Header', 
        'eventLabel' : `Click to ${val}`
      });      
});


//Click handler on footer links for GTM push
$(document).on('click', '.footer-link', function() {
    let val = $(this).data('val')
    dataLayer.push({
        'event': 'customEvent',
        'eventCategory' : 'Navigation',
        'eventAction' : 'Footer', 
        'eventLabel' : `${val}`
      });      
});

//Click handler for click list ads DL push
$(document).on('click', '.mav-partner__button', function() {
    let carrier = $(this).closest(".mav-partner__featured").data("carrier");
    console.log('boop');
    dataLayer.push({
        'event': 'click_listing',
        'insurance_partner' : carrier,
        'insurance_type' : ''
      });              
});

// display thank you and hide LP
function hideContent() {
    $(".lpa-content").hide();
    $("#thank-you").show();

    $([document.documentElement, document.body]).animate({
        scrollTop: $("body").offset().top
    }, 500);

    if($("#thank-you").attr("data-clicklist") == "enabled") {
        console.log("load click list");

        let zip = localStorage.getItem('zipcode');
        let gender = localStorage.getItem('gender');
        let dob = localStorage.getItem('birth_date');
        window.MediaAlphaExchange = {
            "data": {
               "zip": zip,
               "birth_date": dob,
               "gender": gender
            },
            "placement_id": pId,
            "sub_1": "test sub id",
            "type": "ad_unit",
            "version": 17
        };
        MediaAlphaExchange__load('click-listing-container');
        
        $(".lpa-footer").removeClass("is-sticky");
    }
}

//Landing and Thank You pages GTM push
function gtmDataLayerPush(){
    if(window.location.href.slice(window.location.href.indexOf('#') + 1) == 'thank-you'){
        dataLayer.push({
            'event': 'event_pageView', 
            'pageName': 'Landing Page - Lead Form Submission Confirmation',  
            'pageType': 'Landing Page - Lead Form Submission Flow', 
            'pageCategory': 'Lead Form Submission Confirmation',
            'virtualPageURL': window.location.pathname,
            'virtualPage': document.title
        });
    } else {
        dataLayer.push({
            'event': 'event_pageView', 
            'pageName': 'Landing Page - Rapid Decision Life Insurance', 
            'pageType': 'Landing Page - Lead Form Submission Flow', 
            'pageCategory': 'Request A Quote Today Page',
            'virtualPageURL': window.location.pathname,
            'virtualPage': document.title
        });
    }
}

//Form submission GTM push
function gtmDataQuotePush() {
    dataLayer.push({
        'event': 'customEvent',
        'eventCategory' : 'Landing Page - Lead Submission Flow',
        'eventAction' : 'Submit', 
        'eventLabel' : 'Request A Quote Today',
      });      
}

function getQuoteData(payload, callback) {
    /* payload setup
        {
            age: 40,
            employed: "1", // "1" for yes, empty string for no
            gender: "female",
            health: "3",
            state: "CT"
        }
    */
    const quoteEndpoint = "https://fidelitylife.com/wp-json/quotes/v1/quote";
    $.post(quoteEndpoint, payload, function(response) {
        if (callback) {
            callback(response);
        } else {
            console.log(response);
        }
    });
}

$(document).on('keydown', '#testimonialsCarousel', function(e) {
    if(e.which == 37 && e.key == 37) {
        $(".carousel-control-prev").focus();
    } else if(e.which == 39 && e.keyCode == 39) {
        $(".carousel-control-next").focus();
    } else {
        return;
    }
});

$(function() {
    const subdomain = "https://term.fidelitylife.com";
    var slug = window.location.pathname;
    $("input[name=tcpa_url]").val(subdomain + slug);

    window.getQuoteData = getQuoteData;
    setupFormListeners();
    gtmDataLayerPush();
    Inputmask().mask(document.querySelectorAll("input"));
    var url_vars = getUrlVars();
    var counter = 1;
    var dynamicLink = $("a#headerLogo").attr('href') + "?";

    for(var i in url_vars)
    {
        if(counter > 1) {
            dynamicLink += "&"
        }

        // console.log(i + " == " + url_vars[i]);
        switch(i) {
            case 'source':
            case 'campaign_source':
                $("input[name='campaign_source']").val(url_vars[i]);
                dynamicLink += "campaign_source="+url_vars[i];
                break;
            case 'mscklid':
                $("input[name='microsoft_clickid_fla']").val(url_vars[i]);
                break;
            case 'fbclid':
                $("input[name='facebook_clickid_fla']").val(url_vars[i]);
                break;
            case 'utm_medium':
                $("input[name='utm_medium_fla']").val(url_vars[i]);
                dynamicLink += "utm_medium="+url_vars[i];
                break;
            case 'utm_source':
                $("input[name='utm_source_fla']").val(url_vars[i]);
                dynamicLink += "utm_source="+url_vars[i];
                break;
            case 'utm_campaign':
                $("input[name='utm_campaign_fla']").val(url_vars[i]);
                dynamicLink += "utm_campaign="+url_vars[i];
                break;
            case 'utm_term':
                $("input[name='utm_term_fla']").val(url_vars[i]);
                dynamicLink += "utm_term="+url_vars[i];
                break;
            case 'gclid':
                $("input[name='google_clickid_fla']").val(url_vars[i]);
                dynamicLink += "gclid="+url_vars[i];
                break;
            case 'provider_name_fla':
                $("input[name='provider_name_fla']").val(url_vars[i]);
                break;
            case 'cid_fla':
                $("input[name='cid_fla']").val(url_vars[i]);
                break;            
            case 'gender': //URL read for checkbox elements in form
                $("input[name='gender'][value='"+url_vars[i]+"']").attr('checked', true);
                break;
            case 'p_id':
                pId = url_vars[i];
                break;
            default:
                $("input[name='"+i+"']").val(url_vars[i]);
                break;
        }
        counter++;
    }

    $("input[name='google.client_id']").val(document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join("."));
    $("a#headerLogo").attr('href', dynamicLink);

    
    window.onhashchange = function() {
        window.location.reload();
    }

    if($("body").height() <= $(window).height()) {
        $(".lpa-footer").addClass("is-sticky");
    }

    if(window.location.href.indexOf('#thank-you') > -1) {
        hideContent();
    }

    $("#testimonialsCarousel").carousel({
        interval: false,
        keyboard: false
    });

    $("#request").on("click", function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("body").offset().top - 500
        }, 500);
    });

    $(window).scroll(function(){
        var header = $('.lpa-header'),
            scroll = $(window).scrollTop();
      
        if (scroll >= 1) header.addClass('is-sticky');
        else header.removeClass('is-sticky');
    });
    
    $(window).on("load", function(){
        Invoca.PNAPI.run()
    })
});